export const getMetodosPago = async () => {
    try {
        const axios = window.axios;
        const response = await axios.get("api/metodos-pago");
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};